import styled, { css } from 'styled-components'

import { Body } from '@nx/fire/typography'

export const StyledAccordionItem = styled.li<{ $showDivider?: boolean }>`
  border-bottom: 2px solid ${({ theme }) => theme.colours.grey['45']};
  position: relative;

  ${({ $showDivider }) =>
    !$showDivider &&
    css`
      border-bottom: none;
    `}
`

export const StyledAccordionTitle = styled.h3`
  margin: 0;
`

export const StyledAccordionButton = styled(Body)`
  display: flex;
  justify-content: space-between;
  background-color: rgb(255 255 255 / 0%);
  border: 0;
  padding: 15px 0;
  width: 100%;
  cursor: pointer;

  &:focus-visible {
    outline-style: auto;
    outline-color: currentcolor;
    outline-color: -webkit-focus-ring-color;
    outline-offset: 5px;
  }

  &[aria-expanded='true'] {
    color: ${({ theme }) => theme.colours.primary.charcoal};
    ${({ theme }) => theme.fontStyles.sourceSans.medium}
  }

  &:hover {
    text-decoration: underline;
  }
`

export const StyledAccordionPanel = styled.div<{ $height?: number }>`
  max-height: ${({ $height }) => ($height ? `${$height}px` : 0)};
  transition: max-height 0.25s ease-out;
  overflow: hidden;
`

export const StyledAccordionPanelInner = styled.div`
  p,
  span {
    ${({ theme }) => theme.typography.body.M}
    &:last-child {
      margin-bottom: 10px;
    }
  }
`

export const StyledAccordionContent = styled.div`
  padding: 20px;
`

export const StyledAccordionLotSymbols = styled.div`
  td {
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 3px;
    vertical-align: middle;
    min-width: 45px;
  }
`

export const StyledIcon = styled.svg`
  width: 28px;
  height: 28px;
  margin-right: 5px;
`
